import { washImageFor11, washCC, wash11Cart,washArabic } from '@/utils/wash.js'
const washData = (node) => {
  try {
    washImageFor11(node)
    washCC(node)
    wash11Cart(node)
    washArabic(node)
  } catch (err) {
    console.log('err--', err)
  }
}
export { washData }
